/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ch_Entry_TInputs */

const en_cp_ch_entry_t = /** @type {(inputs: Cp_Ch_Entry_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry requirements`)
};

const id_cp_ch_entry_t = /** @type {(inputs: Cp_Ch_Entry_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syarat entri`)
};

/**
* | output |
* | --- |
* | "Entry requirements" |
*
* @param {Cp_Ch_Entry_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ch_entry_t = /** @type {((inputs?: Cp_Ch_Entry_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ch_Entry_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ch_entry_t(inputs)
	return en_cp_ch_entry_t(inputs)
});